
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ProjectCalculations": [
      "NewBuildingCalculations",
      "NewApartmentCalculations",
      "BuyingHouseCalculations"
    ],
    "ProjectFormValues": [
      "NewBuildingFormValues",
      "NewApartmentFormValues",
      "BuyingHouseFormValues",
      "RenovationHouseFormValues",
      "PropertyValuationFormValues"
    ]
  }
};
      export default result;
    